module.exports = __webpack_public_path__ + "static/media/new_snow.d7c1bbfa.svg";